import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from "./App";

const mountApp = (node) => {
  // Reuse existing root if available to avoid duplicate createRoot calls
  let root = node._reactRoot;
  if (!root) {
    root = ReactDOM.createRoot(node);
    node._reactRoot = root;
  }
  const divId = node.id;
  root.render(
    <BrowserRouter>
      <App divId={divId} />
    </BrowserRouter>
  );
};

// Turbo-compatible mounting
document.addEventListener("turbo:load", () => {
  // Mount app for each specific page div
  const rootDivs = [
    'react-root-home',
    'react-root-kolkata-trams',
    'react-root-general-private-buses-kolkata-howrah',
    'react-root-district-series-buses-kolkata-howrah',
    'react-root-miscellaneous-private-buses-kolkata-howrah',
    'react-root-general-private-buses-other-districts',
    'react-root-government-non-ac-buses-kolkata-howrah',
    'react-root-government-ac-buses-kolkata-howrah',
    'react-root-search-for-routes',
    'react-root-vehicle-route-details'
  ];
  
  rootDivs.forEach(divId => {
    const node = document.getElementById(divId);
    if (node) {
      mountApp(node);
    }
  });
});

// Initial mount if Turbo hasn't fired yet (for initial page load)
if (document.readyState === "complete" || document.readyState === "interactive") {
  // Mount app for each specific page div
  const rootDivs = [
    'react-root-home',
    'react-root-kolkata-trams',
    'react-root-general-private-buses-kolkata-howrah',
    'react-root-district-series-buses-kolkata-howrah',
    'react-root-miscellaneous-private-buses-kolkata-howrah',
    'react-root-general-private-buses-other-districts',
    'react-root-government-non-ac-buses-kolkata-howrah',
    'react-root-government-ac-buses-kolkata-howrah',
    'react-root-search-for-routes',
    'react-root-vehicle-route-details'
  ];
  
  rootDivs.forEach(divId => {
    const node = document.getElementById(divId);
    if (node) {
      mountApp(node);
    }
  });
}
